var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"my-tracks"},[_c('tracks',{attrs:{"filter":{ type: 'user', value: _vm.$store.getters.session.user.id }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }